import React from 'react'
import PropTypes from 'prop-types'

import { SPACING } from '../components/constants.js'
import Slide from '../components/Slide.jsx'
import Margin from '../components/Margin.jsx'
import Text from '../components/Text.jsx'
import Align from '../components/Align.jsx'
import Grid from '../components/Grid.jsx'

import usePosition from '../hooks/usePosition.js'
import useRect from '../hooks/useRect.js'

import logo from '_static/img/data-logo-white-small.png'
import backgroundImage from '_static/img/audience-insights/slides/section_bg-intro.png'
import datasphereLogo from '_static/img/datasphere-white.png'

const Intro = (props) => {
  const { title } = props

  const [Rect, rect] = useRect()
  const [titleRef, titleRect] = usePosition()
  const [poweredByRef, poweredByRect] = usePosition()

  return (
    <Slide>
      <Rect />
      <image href={backgroundImage} height={rect.height} width={rect.width} x={0} y={0} />
      <Margin left={240} top={SPACING} right={240} bottom={SPACING}>
        <Grid
          direction="vertical"
          gap={16}
          align={{ y: 'center' }}
          items={[
            {
              component: <image href={logo} width={234} height={40} />,
              size: { height: 80 },
            },
            {
              component: (
                <Text
                  value={title}
                  gRef={titleRef}
                  fill="#ffffff"
                  fontSize={64}
                  fontWeight={700}
                  width={1200}
                />
              ),
              size: titleRect,
            },
          ]}
        />
        <Align
          childrenRect={{ height: 193 / 4 }} // same as image's height bellow
          x="left"
          y="bottom"
        >
          <Text
            value="Powered by"
            gRef={poweredByRef}
            width={700}
            fill="#ffffff"
            fontSize={40}
            fontWeight={400}
          />
          <image
            href={datasphereLogo}
            x={poweredByRect.width + 16}
            width={1000 / 4} // original image width
            height={193 / 4} // original image height
          />
        </Align>
      </Margin>
    </Slide>
  )
}

Intro.propTypes = {
  title: PropTypes.string,
}

Intro.defaultProps = {
  title: '',
}

export default Intro
